import React from 'react';

const Share = props => (
    <div>
    </div>
);

export default Share;



// WEBPACK FOOTER //
// ./src/components/Share.js